import React, { Component } from "react";
import { Alert, Form, Col, Button, Tooltip, Badge, Modal } from "antd";
import FilesUpload from "nbugs-files-upload";
import { connect } from "dva";
import router from "umi/router";
import { ENV } from "@/services/utils";
import ListPage from "../../../../../../components/ListPage";
import FormCreate from "../../../../../../components/FormCreate";
import { GetQueryString } from "../../../../../../utils/utils";
import OperateDropdown from "../../../../../../components/OperateDropdown";
import { url } from "../../../services/service-utils";
import styles from "./index.less";

const { ListSearch, ListTable } = ListPage;
const { FormSelect, FormTitle } = FormCreate;

const selectData = [
  {
    value: "0",
    label: "全部"
  },
  {
    value: "1",
    label: "已完成"
  },
  {
    value: "2",
    label: "未完成"
  }
];
const searchSelect = {
  "0": "",
  "1": true,
  "2": false
};
const statusMap = {
  true: "success",
  false: "error"
};

const statusNameMap = {
  true: "已完成",
  false: "未完成"
};

const nowDownloadUrl = {
  1: "project/statistics/self/list/download", // 自评统计列表的导出
  2: "project/statistics/other/list/download" // 网评统计列表的导出
};

@Form.create()
@connect(({ projectStatistics }) => ({
  ...projectStatistics
}))
class ReportStatistics extends Component {
  constructor(props) {
    super(props);
    this.projectId = GetQueryString("currentProjectId");
    const { tab } = props;
    const columns = [
      {
        title: "评价对象",
        dataIndex: "orgName",
        width: 330,
        fixed: "left",
        render: orgName => (
          <Tooltip placement="top" title={orgName}>
            <span>
              {orgName?.length <= 20
                ? orgName
                : `${orgName?.substring(0, 20)}...`}
            </span>
          </Tooltip>
        )
      },
      {
        title: "自评分数",
        dataIndex: tab === 2 ? "selfEvaluationScore" : "score"
      },
      {
        title: tab === 2 ? "网评进度" : "自评进度",
        render: record => {
          const { completeIndexCount, indexCount } = record;
          return (
            <span style={{ color: "#1785EC" }}>
              {`${completeIndexCount}/${indexCount}`}
            </span>
          );
        }
      },
      {
        title: tab === 2 ? "网评状态" : "填报状态",
        dataIndex: "complete",
        render: complete => {
          const statusCls = statusMap[complete];
          const statusName = statusNameMap[complete];
          return <Badge status={statusCls} text={statusName} />;
        }
      },
      {
        title: "操作",
        width: 200,
        fixed: "right",
        render: record => {
          const { appendix } = record;
          const data = appendix
            ? [
                {
                  text: this.renderReportDetailBtn(record)
                },
                {
                  text: this.renderSelfReportBtn(record)
                }
              ]
            : [
                {
                  text: this.renderReportDetailBtn(record)
                }
              ];
          return <OperateDropdown data={data} />;
        }
      }
    ];
    this.state = {
      searchValue: {
        complete: "",
        param: ""
      },
      columns,
      showAppendixModal: false,
      currentAppendix: ""
    };
    if (tab === 2 && !columns.some(item => item.title === "网评分数")) {
      columns.splice(3, 0, {
        title: "网评分数",
        dataIndex: "otherEvaluationScore"
      });
    }
  }

  componentDidMount() {
    this.getDataList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getDataList(pageInfo);
  };

  getDataList = pageInfo => {
    const { dispatch, tab } = this.props;
    const { searchValue } = this.state;
    dispatch({
      type: "projectStatistics/fetchDataList",
      payload: {
        projectId: this.projectId,
        page: 1,
        pageSize: 10,
        ...pageInfo,
        ...searchValue
      },
      nowTab: tab
    });
  };

  // 重置时的回调
  handleReset = () => {
    this.setState(
      {
        searchValue: {
          complete: "",
          param: ""
        }
      },
      () => {
        this.getDataList();
      }
    );
  };

  // 点击搜索时的回调
  handleQuery = values => {
    const { complete, param } = values;
    this.setState(
      {
        searchValue: {
          complete: searchSelect[complete],
          param
        }
      },
      () => {
        this.getDataList();
      }
    );
  };

  handleClickCheck = record => {
    const { appendix } = record;
    // 查看自评报告
    this.setState({
      showAppendixModal: true,
      currentAppendix: appendix
    });
  };

  handleModal = () => {
    this.setState({
      showAppendixModal: false
    });
  };

  // 跳转网评细则 || 自评细则
  handleJumpTree = record => {
    const { tab } = this.props;
    const { orgId } = record;
    if (tab === 1) {
      router.push(
        `/supervision/norm/project/overview/statistics/evaluationSelfTree?currentProjectId=${this.projectId}&nowOrgId=${orgId}`
      );
    }
    if (tab === 2) {
      router.push(
        `/supervision/norm/project/overview/statistics/evaluationTree?currentProjectId=${this.projectId}&currentOrgId=${orgId}`
      );
    }
  };

  // 渲染填报细则按钮
  renderReportDetailBtn = record => {
    const { tab } = this.props;
    return (
      <a onClick={() => this.handleJumpTree(record)}>
        {tab === 1 ? "填报细则" : "网评细则"}
      </a>
    );
  };

  // 渲染自评报告按钮
  renderSelfReportBtn = record => {
    return <a onClick={() => this.handleClickCheck(record)}>自评报告</a>;
  };

  render() {
    const {
      form,
      spinProps,
      pageInfo,
      dataList,
      notCompleteCount,
      totalOrgCount,
      tab
    } = this.props;
    const { columns, showAppendixModal, currentAppendix } = this.state;
    const { getFieldsValue } = form;

    const formItemProps = {
      colon: true,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    };

    const alertProps = {
      description: "使用说明：以下为参与本次项目的各被督查单位的自评填报情况。",
      type: "info",
      showIcon: true,
      closable: true
    };

    const pageProps = {
      className: styles.root,
      spinProps
    };

    const formSelectProps = {
      form,
      optionData: selectData,
      value: "0",
      label: "填报状态",
      keyName: "complete"
      // formItemProps
    };

    const formTitleProps = {
      form,
      value: "",
      keyName: "param",
      label: "搜索",
      isRequired: false,
      placeholder: "请输入评价对象名称搜索",
      formItemProps: {
        style: {
          marginBottom: 0
        }
      }
    };

    const listSearchProps = {
      form,
      className: "searchWrapper",
      handleReset: this.handleReset,
      handleQuery: this.handleQuery,
      buttonColProps: {
        style: {
          textAlign: "right"
        }
      },
      formLayoutProps: formItemProps
    };

    const listTableProps = {
      pageInfo,
      columns,
      list: dataList,
      onPageChange: this.handlePaginationChange
    };

    return (
      <ListPage {...pageProps}>
        <Alert {...alertProps} />
        <ListSearch {...listSearchProps}>
          <Col span={8}>
            <FormSelect {...formSelectProps} />
          </Col>
          <Col span={8}>
            <FormTitle {...formTitleProps} />
          </Col>
        </ListSearch>
        <div className="reportNews">
          <span className="reportBG" />
          <span className="reportNum">
            {`项目被督查单位${
              tab === 2 ? "网评" : "自评"
            }填报情况：被督查单位共 ${totalOrgCount}；未${
              tab === 2 ? "网评" : "填报"
            }完成 ${notCompleteCount}`}
          </span>
        </div>
        <div className="exportData">
          <Button
            type="primary"
            href={`${url.url}/${nowDownloadUrl[tab]}?projectId=${
              this.projectId
            }&complete=${searchSelect[getFieldsValue()?.complete] ||
              ""}&param=${getFieldsValue()?.param || ""}`}
          >
            导出
          </Button>
        </div>
        <ListTable {...listTableProps} />
        {showAppendixModal && (
          <Modal
            visible
            centered
            title="自评报告"
            onOk={this.handleModal}
            onCancel={this.handleModal}
          >
            <FilesUpload
              edit={1}
              type="pc"
              APIEnv={ENV}
              groupId={currentAppendix}
              key={currentAppendix}
            />
          </Modal>
        )}
      </ListPage>
    );
  }
}

export default ReportStatistics;
